
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M396 322.738c0 1.23-1.039 2.273-2.273 2.273H46.273c-1.234 0-2.273-1.043-2.273-2.273V59.375c0-1.234 1.039-2.273 2.273-2.273h347.454c1.234 0 2.273 1.04 2.273 2.273v263.363zm-206.68 60.18h61.364v-45.906H189.32v45.906zM393.727 45.102H46.273C38.402 45.102 32 51.504 32 59.375v263.363c0 7.871 6.402 14.273 14.273 14.273H177.32v45.911h-56.593c-3.313 0-6 2.684-6 6 0 3.312 2.687 6 6 6h198.546c3.313 0 6-2.688 6-6 0-3.316-2.687-6-6-6h-56.589v-45.91h131.043c7.871 0 14.273-6.403 14.273-14.274V59.375c0-7.87-6.402-14.273-14.273-14.273z"}}),_c('path',{attrs:{"d":"M377.184 276.191H62.82a6 6 0 100 12h314.364a6 6 0 000-12M126 244.191h20v-75.046h-20v75.046zm-6 12h32c3.312 0 6-2.687 6-6v-87.046c0-3.313-2.688-6-6-6h-32c-3.312 0-6 2.687-6 6v87.046c0 3.313 2.688 6 6 6zM182 244.192h20V140.758h-20v103.434zm-6 11.999h32c3.312 0 6-2.687 6-6V134.758c0-3.313-2.688-6-6-6h-32c-3.312 0-6 2.687-6 6v115.433c0 3.313 2.688 6 6 6zM238 244.191h20V113.918h-20v130.273zm-6 12h32c3.312 0 6-2.687 6-6V107.918c0-3.312-2.688-6-6-6h-32c-3.313 0-6 2.688-6 6v142.273a6 6 0 006 6zM294 244.192h20v-47.434h-20v47.434zm-6 11.999h32c3.312 0 6-2.687 6-6v-59.433c0-3.313-2.688-6-6-6h-32c-3.312 0-6 2.687-6 6v59.433c0 3.313 2.688 6 6 6z"}})])])
          )
        }
      }
    